import React, { memo } from 'react';
import cn from 'classnames';

import PercentSpinner from '@components/common/PercentSpinner';

import { DEFAULT_DECIMAL_PRESICION } from '@constants/common';

import styles from './PercentsSpinner.module.scss';

interface IPercentsSpinnerProps {
	percentsProgress?: number;
	savedBranches?: number;
	totalBranchesToSave?: number;
	nameData?: string;
	isOverlay?: boolean;
}

const PercentsSpinner = ({
	percentsProgress = 0,
	savedBranches = 0,
	totalBranchesToSave = 0,
	nameData = 'branches',
	isOverlay = false,
}: IPercentsSpinnerProps) => {
	return (
		<div className={cn(styles.percentLoader,
			{
				[styles.overlay]: isOverlay,
			})}>
			<PercentSpinner percent={percentsProgress} />
			<div className={styles.descriptions}>
				Please wait... {percentsProgress.toFixed(DEFAULT_DECIMAL_PRESICION)}%
				{totalBranchesToSave > 0 && (
					<>
						<br />
						Done {savedBranches} of {totalBranchesToSave} {nameData}
					</>
				)}
			</div>
		</div>
	);
};

export default memo(PercentsSpinner);
